import api from '../token';

export const DeleteProcesso = async (dados) => {
  try {
    const response = await api.post('/deleteProcesso', dados);
    return response.data;
  } catch (error) {
   
    return [];
  }
};